import { render, staticRenderFns } from "./DownloadRelatedFiles.vue?vue&type=template&id=1a162b4c&scoped=true&"
import script from "./DownloadRelatedFiles.vue?vue&type=script&lang=js&"
export * from "./DownloadRelatedFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a162b4c",
  null
  
)

export default component.exports